import React from 'react';
import Footer from '../../components/Layout/Footer';
import { getAuthToken, storeUserData } from '../../components/Util';
import axios from 'axios';
import api from '../../config/api';
import { toast } from 'react-toastify';
import { withRouter } from '../../config/withRouter';
import SubHeader from '../../components/Layout/SubHeader';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';

class PurchaseViewScreen extends React.Component {
    constructor(props) {
        super(props);
        const { id } = this.props.params;
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            isLoading: false,
            data: {},
            id: id,
        }
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);
            setTimeout(() => {
                self.getData();
            });
        }
    }

    getData() {
        const self = this;
        self.setState({ 'isLoading': true })
        axios({
            method: 'GET',
            url: api.PurchaseSingle + self.state.id + "?lang=" + self.state.lang,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
            }
        }).then(function (ress) {
            self.setState({
                'isLoading': false,
                data: ress.data.message
            })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ 'isLoading': false });
            self.setState({ ProgressBar: false });
        });
    }

    handleCopy(text) {
        navigator.clipboard.writeText(text)
        toast.success(strings["Copy Incoive ID"]);
    };

    formatDate = (date) => {
        // Convert to DD/MM/YYYY
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    render() {
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <div className='purchaseHistoryScreen'>
                    <SubHeader data={{ title: strings["Invoice"] }} />
                    <main className="align-container">
                        <div className="expand-container" style={{ height: 'auto', paddingBlock: 10 }}>
                            <div className="top-invoice">
                                <p>{strings["Invoice No:"]} <span>{(this.state.data && this.state.data.invoice_no) ? this.state.data.invoice_no : ''}</span></p>
                                <button onClick={() => this.handleCopy((this.state.data && this.state.data.invoice_no) ? this.state.data.invoice_no : '')} id="copyButton" className="copy-button">{strings["copyButton"]}</button>
                                <p>{this.formatDate((this.state.data && this.state.data.created_at) ? this.state.data.created_at : '')}</p>
                            </div>
                            <div className="invoice-header">
                                <p>{strings["Id"]}</p>
                                <p>{strings["Name"]}</p>
                                <p>{strings["Price"]}</p>
                                <p>{strings["QTY"]}</p>
                                <p>{strings["Total"]}</p>
                            </div>
                            {this.state.data && this.state.data.itemlist ?
                                <>
                                    {this.state.data.itemlist.map((item, i) =>
                                        <div key={"invoice_itemlist_001_" + i} className="invoice-content">
                                            <p>{i}</p>
                                            <p>{item.item_name}</p>
                                            <p>{item.item_amount.toFixed(2)}</p>
                                            <p>{item.item_qty}</p>
                                            <p>{item.total.toFixed(2)}</p>
                                        </div>
                                    )}
                                </>
                                : null}
                            <div className="mid-invoice">
                                <p>{strings["Subtotal:"]} <span>{(this.state.data && this.state.data.created_at) ? this.state.data.subtotal.toFixed(2) : ''}</span></p>
                                <p>{strings["Discount:"]} <span>{(this.state.data && this.state.data.created_at) ? this.state.data.discount.toFixed(2) : ''}</span></p>
                                <p>{strings["Tax:"]} <span>{(this.state.data && this.state.data.created_at) ? this.state.data.tax.toFixed(2) : ''}</span></p>
                            </div>
                            <div className="expand-bottom">
                                <p>{strings["Grand Total:"]} <span>{(this.state.data && this.state.data.created_at) ? this.state.data.grand_total.toFixed(2) : ''}</span></p>
                            </div>
                        </div>

                    </main>
                    <Footer />
                </div>
            </>
        );
    }
}

export default withRouter(PurchaseViewScreen);
